import React, { useState, useEffect } from 'react';
import SummaryTable from './SummaryTable';
import PredictedGraph from './PredictedGraph';

const Prediction = (props) => {
  const [summaryTable, setSummaryTable] = useState([]);
  const [feedbackForm, setFeedbackForm] = useState({});
  const [graphprops, setGraphprops] = useState(props.graphprops);
  const [predictionsType, setPredictionsType] = useState('');
  const [selectionDate, setSelectionDate] = useState(props.selectionDate);

  const updateSummaryTable = (summaryTable, predictionsType) => {
    setSummaryTable(summaryTable);
    setPredictionsType(predictionsType);
  };

  const updateFeedbackForm = (feedbackForm) => {
    setFeedbackForm(feedbackForm);
  };

  useEffect(() => {
    setGraphprops(props.graphprops);
    setSelectionDate(props.selectionDate);
  }, [
    props.graphprops,
    props.selectionDate,
    props.selectionMonth,
    props.selectionWeek,
    props.deviceId,
    props.shift,
  ]);

  return (
    <div style={{ height: '70%', marginTop: '40px' }}>
      <PredictedGraph
        graphprops={graphprops}
        selectionDate={selectionDate}
        summaryTable={updateSummaryTable}
        feedbackForm={updateFeedbackForm}
        feedbackFormData={feedbackForm}
        selectionDateRange={props.selectionDateRange}
        // refereshData={(refereshData) => {
        // }}
      />
      <SummaryTable
        summaryTable={summaryTable}
        predictionsType={predictionsType}
        feedbackForm={feedbackForm}
        // refereshData={(refereshData) => {
        //   // Handle refereshData if needed
        // }}
      />
    </div>
  );
};

export default Prediction;